import React from 'react'

import './Spotify.css'

export default function Spotify() {
  return (
    <div className="BisBlue">
      <div className="bb__layout">
        <div className="bb__content">
          <img className="jam__logo" src="/images/jammming-logo.png" alt="Jammming Logo" fetchPriority='high'/>
          <p className="bb__desc">
            A playlist app that uses Spotify's Web API to allow the user to 
            search and add tracks to a playlist they can directly upload to Spotify. Uses OAuth 2.0 with PCKE.
          </p>
          <div className="bb__videoContainer">
            <video className="bb__video"
                fetchPriority='high'
                preload='auto'
                autoPlay 
                muted 
                loop 
                playsInline>
                  <source src="/videos/spotify-preview.mp4" type="video/mp4" />
            </video>
          </div>
          <p className="bb__tools">
            Tools used: React.js, HTML/CSS, Spotify Web API, Claude Code
          </p>
        </div>
      </div>

    </div>
  )
}
